/**
 * 订单管理 订单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>激活码统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!-- <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="关键词:">
        <el-input
          size="small"
          v-model="formInline.word"
          placeholder="请输入关键词"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form> -->
    <!--列表-->
    <div v-for="(item,index) in listData" :key="index" style="padding: 15px 0 5px;">
        <div class="tip" style="display: flex;margin-top: 8px;">
        <div v-if="item.channelName!='合计'">渠道名：{{ item.channelName }}</div>
        <div>合计：{{ item.count }}</div>
        <div>使用数：{{item.use}}</div>
        <div>作废数：{{item.destroy}}</div>
        <div>剩余数：{{item.left}}</div>
    </div>
        <el-table
        v-if="item.list&&item.list[0]"
      size="small"
      :data="item.list"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;margin-top: 8px;"
    >  
    <el-table-column
        align="center"
        prop="type"
        label="类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="count"
        label="合计"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="use"
        label="使用数"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="destroy"
        label="作废数"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="left"
        label="剩余数"
        show-overflow-tooltip
      >
      </el-table-column>
    
    
      <!-- <el-table-column align="center" prop="useDays" label="使用时间" width="110" show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column
        align="center"
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="useTime"
        label="兑换时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="status"
        label="状态"
        show-overflow-tooltip
      >
      </el-table-column> -->
    </el-table>   
    </div>

  
  </div>
</template>

<script>
import {
  actCodeReportPage
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.getdata();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeTime() {
      console.log(123);
      this.dayType.forEach((item) => {
        if (item.value == this.addForm.type) {
          if (item.key == "月") {
            this.timeData = "个月";
          } else {
            this.timeData = item.key;
          }
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      actCodeReportPage(parameter)
        .then((res) => {
          this.loading = false;
          if (res.success == false) {
            this.$message({
              type: "info",
              message: res.msg,
            });
          } else {
            this.listData = res.data
            // 分页赋值
            console.log('this.listData',this.listData)
            // this.pageparm.currentPage = this.formInline.pageNo + 1;
            // this.pageparm.pageSize = res.data.pageSize;
            // this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },

  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.tip div{
    margin-right: 25px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/actcode/spacereport.vue